import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Brokers from './components/Brokers';
import WhoWeAre from './components/WhoWeAre';
import Contact from './components/Contact';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Dashboard from './components/SimpleDashboard';
import MarketOverview from './components/MarketOverview';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App upm-traders-theme">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/brokers" element={<Brokers />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/market-overview" element={<MarketOverview />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;